export default "__VITE_ASSET__Dp5$hHi___"